import React from "react";
import DailyExpiredReport from "app/modules/DailyExpiredReport";

export default function DailyExpiredReportPage() {
    return <DailyExpiredReport/>
}